@if (!universalService.isMobileDevice) {
  <app-create-options (fileRenamed)="confirmOperation($event)" (createFolder)="createNewFolder()"/>
}
@if (!universalService.isMobileDevice) {
  <lib-create-album [enableButton]="fileOpsImplementationRef.enableButton" (createAlbumValidation)="validateBeforeCreatingAlbum($event)" />
}
<app-context-menu (setFavorite)="confirmOperation($event)" (unSetFavorite)="confirmOperation($event)" (restoreItems)="restoreFiles()"
  (deleteParmanently)="deleteParmanent()" (setShare)="confirmShareOperation($event)" (createFolder)="createNewFolder()"/>
@if (universalService.userLoggedIn && !universalService.hideLeftMenu) {
  <upload-component [enableButton] = "fileOpsImplementationRef.enableButton" (createFolderValidation)="validateBeforeCreatingFolder($event)"/>
}
@if (universalService.showPreview) {
  <lib-preview (setFavorite)="confirmOperation($event)" (unSetFavorite)="confirmOperation($event)" (setShare)="confirmShareOperation($event)"/>
}
@if (universalService.userLoggedIn) {
  <lib-download />
}
@if (!this.universalService.showMobAlbumInfoPanel) {
  <lib-top-menu
    (setFavorite)="confirmOperation($event)" (unSetFavorite)="confirmOperation($event)" (restoreItems)="restoreFiles()"
    (deleteParmanently)="deleteParmanent()" (createFolder)="createNewFolder()" (setShare)="confirmShareOperation($event)"/>
}
<common-private-folder-password />
@if (universalService.showPassPhraseReset) {
  <lib-reset-passpharse/>
}
@if (this.universalService.isServerError && universalService.userLoggedIn) {
  <lib-error-screen/>
}
<app-create-folder
  [enableButton]="fileOpsImplementationRef.enableButton"
  (closecreateModal)="closeCreateModal()" (createFolderMove)="createFolderAndMove()"
  (createFolderValidation)="validateBeforeCreatingFolder($event)" (createFolderCopy)="createFolderAndCopy()"
  (gotoPreviousScreen)="goBackToPreviousScreen()"
/>
<app-drag-drop-overlays/>
<app-enable-people-tab-confirmation (closePopUp)="close()"/>
<div class="modal fade" id="operation-in-progress-modal" role="dialog" tabindex="-1" aria-hidden="true"
  [ngStyle]="{'display': showProgressBar ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      @if (!universalService.isMobileDevice) {
        <div class="modal-header">
          @if (currentOperation == 'MOVE') {
            <h5>Moving Item(s)</h5>
          }
          @if (currentOperation == 'COPY') {
            <h5>Copying Item(s)</h5>
          }
          @if (currentOperation == 'TRASH') {
            <h5>Deleting Item(s)</h5>
          }
        </div>
      }

      @if (universalService.isMobileDevice) {
        <div class="mobheader border-bottom-0">
        </div>
      }

      <div class="modal-body border-bottom-0">
        <div class="progressContent m-4">
          <h5>Please wait...</h5>
          @if (currentOperation == 'MOVE') {
            <h6>Moving {{noOfCompletedFiles}} of {{totalFiles}} item(s)
            </h6>
          }
          @if (currentOperation == 'COPY') {
            <h6>Copying {{noOfCompletedFiles}} of {{totalFiles}} item(s)
            </h6>
          }
          @if (currentOperation == 'TRASH') {
            <h6>Deleting {{noOfCompletedFiles}} of {{totalFiles}}
            item(s)</h6>
          }
          <div class="progress">
            <div class="progress-bar" aria-label="progressbar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
              [style.width.%]="progressPercentage">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <iframe id="trashFrame"></iframe> -->

<!-- STATUS POP UP STARTS -->
<div class="modal fade" id="operation-in-progress-modal" role="dialog" tabindex="-1"
  aria-hidden="true" [ngStyle]="{'display': mcImplRef.showCopyStatus ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      @if (!universalService.isMobileDevice) {
        <div class="modal-header">
          <h5>Copying Item(s)</h5>
        </div>
      }

      @if (universalService.isMobileDevice) {
        <div class="mobheader border-bottom-0" >
        </div>
      }

      <div class="modal-body border-bottom-0">
        <div class="progressContent m-4">
          @if (!mcImplRef.copyStatus.includes('Completed') && !mcImplRef.copyStatus.includes('Copied')) {
            <h5>Please wait...</h5>
          }
          <h6>{{mcImplRef.copyStatus}}</h6>
          <div class="progress mt-4">
            @if (mcImplRef.copyStatus != 'Error in copying files.') {
              <div class="progress-bar" aria-label="progressbar" role="progressbar" aria-valuemin="0" aria-valuemax="100" [style.width.%]="mcImplRef.progressPercentage">
              </div>
            }
            @if (mcImplRef.copyStatus == 'Error in copying files.') {
              <div class="progress-bar error-progress" aria-label="progressbar" role="progressbar" aria-valuemin="0" aria-valuemax="100" [style.width.%]="mcImplRef.progressPercentage">
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- STATUS POP UP ENDS -->
